import React, { useState, useEffect, useRef } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
} from "reactstrap";
import axios from "axios";
import Swal from "sweetalert2";
import Select from "react-select";


const ModalCreate = ({ isOpen, toggle, title, token }) => {
  const [rol, setRol] = useState([]);
  const [, setSelectedRol] = useState("");
  const [selectedRol2, setSelectedRol2] = useState("");
  const [, setSelectedMenu] = useState("");
  const [selectedMenu2, setSelectedMenu2] = useState("");
  const [menuDetail, setMenuDetail] = useState([]);
  const [, setFormMode] = useState("none");
  const modalRef = useRef(null);


  const handleRolChange = (selectedOption) => {
    setSelectedRol2(selectedOption.value);
    setSelectedRol(
      rolOptions.find((option) => option.value === selectedOption.value)
    );
  };

  const handleMenuChange = (selectedOption) => {
    setSelectedMenu2(selectedOption.value);
    setSelectedMenu(
      menuDetalleOptions.find((option) => option.value === selectedOption.value)
    );
  };

  useEffect(() => {
    if (token) {
      axios
        .get("/roles", { headers: { Authorization: `Bearer ${token}` } })
        .then((response) => {
          setRol(response.data);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [token]);

  useEffect(() => {
    if (token) {
      axios
        .get("/menudetalle", { headers: { Authorization: `Bearer ${token}` } })
        .then((response) => {
          setMenuDetail(response.data);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [token]);

  const rolOptions = rol.map((option) => ({
    value: option.id,
    label: option.Nombre ?? option.nombre,
  }));
  const menuDetalleOptions = menuDetail.map((option) => ({
    value: option.id,
    label: option.Nombre ?? option.nombre,
  }));

  const handleCreateSubmit = (event) => {
    event.preventDefault();
    axios
      .post(
        "/menuporrol",
        {
          RolId: selectedRol2,
          MenuDetalleId : selectedMenu2,
        },
        { headers: { Authorization: `Bearer ${token}` } }
      )
      .then((response) => {
        Swal.fire({
          icon: "success",
          title: "Creado!",
          text: "el Menú rol ha sido creada con exito",
          showCloseButton: true,
        }).then(() => {
          window.location.reload();
        });
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Error!",
          text: "Ha ocurrido un error al crear el d Menú rol.",
          showCloseButton: true,
        });
      });
  };

  return (
    <Modal ref={modalRef} isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>{title}</ModalHeader>
      <ModalBody>
        <FormGroup>
          <label htmlFor="RolId">Rol:</label>
          <Select options={rolOptions} onChange={handleRolChange}></Select>
        </FormGroup>
        <FormGroup>
          <label htmlFor="MenuId">Menú:</label>
          <Select options={menuDetalleOptions} onChange={handleMenuChange}></Select>
        </FormGroup>
      </ModalBody>

      <ModalFooter>
        <Button onClick={handleCreateSubmit} color="primary" otype="submit">
          Insertar
        </Button>
        <Button color="danger" onClick={() => setFormMode("none")}>
          Cancelar
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ModalCreate;
